"use client";

import { useEffect, useRef, useState } from "react";
import {
  Box,
  Paper,
  Grid,
  Typography,
  Select,
  MenuItem,
  useTheme,
  useMediaQuery,
  Checkbox,
  ListItemText,
} from "@mui/material";
import { ResponsiveBar } from "@nivo/bar";
import axiosInstance from "../Utils/AxoisClient";
import { toast } from "react-toastify";
import CountryFlag from "react-country-flag";
import countryToFlagCode from "../../Components/CountryFlag/CountryFlag";
import { useLocation } from "react-router-dom";
export default function WorkspaceAnalytics() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const ddpDebounceRef = useRef(null);
  const location = useLocation();
  /* -------------------- DYNAMIC DATA -------------------- */

  /* -------------------- STATE -------------------- */
  const [quarter, setQuarter] = useState([]);
  const [country, setCountry] = useState(
    location?.state?.params?.origin_country[0],
  );
  // const [selectedIds, setSelectedIds] = useState(
  //   [location?.state?.params?.id] || []
  // );
  const [selectedIds, setSelectedIds] = useState(() =>
    location?.state?.params?.id ? [location.state.params.id] : [],
  );

  const [bookMarkList, setBookMarkList] = useState([]);
  const [ddpPriceData, setDdpPriceData] = useState([]);
  const [selectedDDPCountryList, setSelectedDDPCountryList] = useState([]);
  const [selectedQuarter, setSelectedQuarter] = useState({
    id: location?.state?.params?.master_period_id,
    name: location?.state?.params?.period_name,
  });
  const [selectedWorkSpace, setSelectedWorkSpace] = useState(
    [location?.state?.params] || [],
  );
  const [costBreakdown, setCostBreakDown] = useState([]);
  const [costBreakdownQuarterWise, setCostBreakDownQuarterWise] = useState([]);
  const selectedSubCategoryId =
    selectedIds.length > 0
      ? bookMarkList.find((o) => o.id === selectedIds[0])?.subcategory_id
      : null;

  const fetchBookMartList = async (value) => {
    const payload = { search: value ? value : "" };
    try {
      const response = await axiosInstance.post(
        `company/analytics/bookmark-list`,
        payload,
      );
      setBookMarkList(response?.data?.data);
    } catch (error) {
      toast.error(error?.data?.data || "Failed to fetch data 🎉", {
        autoClose: 2000,
      });
    }
  };

  // const fetchDDPPriceList = async () => {
  //   const payload = {
  //     bookmark_id: selectedIds ? selectedIds?.join(",") : [""], // comma seprated
  //   };
  //   try {
  //     const response = await axiosInstance.post(
  //       `company/analytics/ddp-price-data`,
  //       payload
  //     );
  //     setDdpPriceData(response?.data?.data);
  //     setQuarter(response?.data?.data?.period);
  //     setSelectedDDPCountryList(response?.data?.data?.origin_country);
  //   } catch (error) {
  //     toast.error(error?.response?.data?.message || "Failed to fetch data 🎉", {
  //       autoClose: 2000,
  //     });
  //   }
  // };

  const fetchDDPPriceList = () => {
    // 🔴 clear previous call
    if (ddpDebounceRef.current) {
      clearTimeout(ddpDebounceRef.current);
    }

    // 🟢 debounce new call
    ddpDebounceRef.current = setTimeout(async () => {
      const payload = {
        bookmark_id: selectedIds?.length ? selectedIds.join(",") : "",
      };
      try {
        const response = await axiosInstance.post(
          "company/analytics/ddp-price-data",
          payload,
        );
        setDdpPriceData(response?.data?.data);
        setQuarter(response?.data?.data?.period);
        setSelectedDDPCountryList(response?.data?.data?.origin_country);
      } catch (error) {
        toast.error(
          error?.response?.data?.message || "Failed to fetch data 🎉",
          { autoClose: 2000 },
        );
      }
    }, 500);
  };

  useEffect(() => {
    return () => {
      if (ddpDebounceRef.current) {
        clearTimeout(ddpDebounceRef.current);
      }
    };
  }, []);

  useEffect(() => {
    fetchBookMartList("");
  }, []);

  useEffect(() => {
    if (selectedIds?.length < 1) return;
    fetchDDPPriceList();
  }, [selectedIds]);

  const toNumber = (v) => {
    if (v === null || v === undefined || v === "") return 0;
    const n = Number(v);
    return Number.isFinite(n) ? Number(n?.toFixed(1)) : 0;
  };

  const getCostBreakDownList = async () => {
    const payload = {
      bookmark_id: selectedIds ? selectedIds?.join(",") : [""],
      quarter_id: selectedQuarter?.id,
    };
    try {
      const response = await axiosInstance.post(
        `company/analytics/cost-breakdown-value`,
        payload,
      );
      const data = response?.data?.data?.breakdown;
      const getKeyAndValue = (kv = {}) => {
        if (!kv || typeof kv !== "object") return { key: "NA", value: 0 };

        if (kv.EXW !== "" && kv.EXW !== null && kv.EXW !== undefined)
          return { key: "EXW", value: kv.EXW };

        if (kv.FOB !== "" && kv.FOB !== null && kv.FOB !== undefined)
          return { key: "FOB", value: kv.FOB };

        if (kv.CIF !== "" && kv.CIF !== null && kv.CIF !== undefined)
          return { key: "CIF", value: kv.CIF };

        return { key: "NA", value: 0 };
      };
      const result = Object.entries(data)?.map(([country, value]) => {
        const { key, value: finalValue } = getKeyAndValue(value?.key_value);
        return {
          country:
            country !== "USA"
              ? country.charAt(0).toUpperCase() + country.slice(1).toLowerCase()
              : country,
          [key]: toNumber(finalValue),
          // EXW: toNumber(value.key_value?.EXW),
          Logistics:
            toNumber(value.origin_cost_data?.logistics_cost) +
            toNumber(value.destination_cost_data?.logistics_cost),

          "Port Charges":
            toNumber(value.origin_cost_data?.origin_customs_clearance) +
            toNumber(
              value.destination_cost_data?.destination_customs_clearance,
            ) +
            toNumber(
              value.destination_cost_data
                ?.destination_terminal_handling_charges,
            ) +
            toNumber(value.origin_cost_data?.origin_terminal_handling_charges),

          "Ocean Freight": toNumber(
            value.ocean_freight_data?.ocean_freight_road_freight,
          ),
          //  +
          // toNumber(value.ocean_freight_data?.insurance),
          Taxes:
            toNumber(value.origin_cost_data?.tax) +
            toNumber(value.origin_cost_data?.export_duty) +
            toNumber(value?.vat_data?.vatCalculated) +
            toNumber(value.origin_cost_data?.additional_charges),

          Tariff: toNumber(value.destination_cost_data?.tariff),

          "Other Duty": toNumber(
            value.destination_cost_data?.other_charge_value,
          ),
        };
      });

      setCostBreakDown(result);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to fetch data 🎉", {
        autoClose: 2000,
      });
    }
  };

  useEffect(() => {
    if (!selectedQuarter?.name || selectedIds.length < 1) return;
    getCostBreakDownList();
  }, [selectedQuarter, selectedIds]);

  const transformQuarterWiseData = (apiData = []) => {
    if (!Array.isArray(apiData)) return [];

    const getKeyAndValue = (kv = {}) => {
      if (!kv || typeof kv !== "object") return { key: "NA", value: 0 };

      if (kv.EXW !== "" && kv.EXW !== null && kv.EXW !== undefined)
        return { key: "EXW", value: kv.EXW };

      if (kv.FOB !== "" && kv.FOB !== null && kv.FOB !== undefined)
        return { key: "FOB", value: kv.FOB };

      if (kv.CIF !== "" && kv.CIF !== null && kv.CIF !== undefined)
        return { key: "CIF", value: kv.CIF };

      return { key: "NA", value: 0 };
    };
    return apiData.flatMap((item) =>
      (item?.data || []).map((row) => {
        const raw = row?.raw_data || {};
        const { key, value: finalValue } = getKeyAndValue(raw?.key_value);
        return {
          quarter: row?.quarter || "",
          // EXW: toNumber(raw.key_value?.EXW),
          [key]: toNumber(finalValue),
          Logistics:
            toNumber(raw.origin_cost_data?.logistics_cost) +
            toNumber(raw.destination_cost_data?.logistics_cost),

          "Port Charges":
            toNumber(raw.origin_cost_data?.origin_customs_clearance) +
            toNumber(raw.destination_cost_data?.destination_customs_clearance) +
            toNumber(
              raw.destination_cost_data?.destination_terminal_handling_charges,
            ) +
            toNumber(raw.origin_cost_data?.origin_terminal_handling_charges),

          "Ocean Freight": toNumber(
            raw.ocean_freight_data?.ocean_freight_road_freight,
          ),
          // + toNumber(raw.ocean_freight_data?.insurance)
          Taxes:
            toNumber(raw.origin_cost_data?.tax) +
            toNumber(raw.origin_cost_data?.export_duty) +
            toNumber(raw?.vat_data?.vatCalculated) +
            toNumber(raw.origin_cost_data?.additional_charges),

          Tariff: toNumber(raw.destination_cost_data?.tariff),

          "Other Duty": toNumber(raw.destination_cost_data?.other_charge_value),
        };
      }),
    );

    // return apiData.map((item) => {
    //   const raw = item?.data || {};

    //   return {
    //     quarter: raw[0]?.quarter,

    //     EXW: toNumber(raw?.key_value?.EXW),

    //     Logistics:
    //       toNumber(raw?.origin_cost_data?.logistics_cost) +
    //       toNumber(raw?.origin_cost_data?.origin_customs_clearance) +
    //       toNumber(raw?.origin_cost_data?.origin_terminal_handling_charges) +
    //       toNumber(raw?.origin_cost_data?.export_duty) +
    //       toNumber(raw?.origin_cost_data?.tax),

    //     OceanFreight:
    //       toNumber(raw?.ocean_freight_data?.ocean_freight_road_freight) +
    //       toNumber(raw?.ocean_freight_data?.insurance),

    //     Tariff: toNumber(raw?.destination_cost_data?.tariff),

    //     Others: toNumber(raw?.destination_cost_data?.additional_charges),
    //   };
    // });
  };

  const getCostBreakdownQuarterWise = async () => {
    const payload = {
      bookmark_id: selectedIds?.join(",") || "",
      origin_country: [country].filter(Boolean).join(","),
    };

    try {
      const response = await axiosInstance.post(
        "company/analytics/cost-breakdown-quarter-wise",
        payload,
      );
      const apiResponse = response?.data?.data || [];
      const chartData = transformQuarterWiseData(apiResponse);
      setCostBreakDownQuarterWise(chartData);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to fetch data 🎉", {
        autoClose: 2000,
      });
    }
  };

  useEffect(() => {
    if (selectedDDPCountryList.length < 0 || selectedIds.length < 0 || !country)
      return;
    getCostBreakdownQuarterWise();
  }, [selectedDDPCountryList, country]);

  const AxisTickWithFlag = ({ x, y, value }) => {
    const countryCode = countryToFlagCode[value];
    if (!countryCode) return null;

    const flagUrl = `https://flagcdn.com/w20/${countryCode.toLowerCase()}.png`;

    const FLAG_W = 18;
    const FLAG_H = 1000;
    const GAP = 6;
    const BAR_GAP = 10;

    return (
      // <g transform={`translate(${x - (FLAG_W + GAP + BAR_GAP)}, ${y})`}>
      <g transform={`translate(${x - 80}, ${y})`}>
        {/* Flag */}
        <image
          href={flagUrl}
          x={0}
          y={-FLAG_H / 2}
          width={FLAG_W}
          height={FLAG_H}
          preserveAspectRatio="xMidYMid meet"
        />

        {/* Label */}
        <text
          x={FLAG_W + GAP}
          y={0}
          dominantBaseline="middle"
          fontSize={12}
          fill="#475569"
        >
          {value}
        </text>
      </g>
    );
  };

  /* -------------------- UI -------------------- */
  return (
    <Box sx={{ p: 2, background: "#f7f8fc", minHeight: "100vh" }}>
      <Paper sx={{ p: 2, borderRadius: 2 }}>
        {/* Header */}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Select
              fullWidth
              size="small"
              multiple
              displayEmpty
              value={selectedIds}
              onChange={(e) => {
                setSelectedIds(e.target.value);
                const selectedObjects = bookMarkList.filter((item) =>
                  Array.isArray(e.target.value)
                    ? e.target.value.includes(item.id)
                    : item.id === e.target.value,
                );

                setSelectedWorkSpace(selectedObjects);
              }}
              renderValue={(selected) => {
                if (selected.length === 0) return "Select Workspace";
                return bookMarkList
                  ?.filter((o) => selected?.includes(o.id))
                  ?.map((o) => o.bookmark_title)
                  .join(", ");
              }}
            >
              <MenuItem disabled value="">
                Select Workspace
              </MenuItem>

              {bookMarkList?.map((item) => {
                const isSelected = selectedIds.includes(item.id);
                const disable =
                  selectedSubCategoryId !== null &&
                  item.subcategory_id !== selectedSubCategoryId &&
                  !isSelected;

                return (
                  <MenuItem key={item.id} value={item.id} disabled={disable}>
                    <Checkbox checked={isSelected} />
                    <ListItemText
                      primary={item.bookmark_title}
                      secondary={`${item.subcategory_name} (${item.destination_country}) (${(item?.period_name && item?.period_name) || ""})`}
                    />
                  </MenuItem>
                );
              })}
            </Select>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="caption" sx={cardHeader}>
              Category
            </Typography>
            <Paper sx={infoCard}>
              <Typography fontWeight={600} color="primary">
                {/* {data.category} */}
                {Array.isArray(selectedWorkSpace)
                  ? selectedWorkSpace[0]?.subcategory_name
                  : ""}
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="caption" sx={cardHeader}>
              Destination Country
            </Typography>
            <Paper sx={infoCard}>
              <Typography fontWeight={600} color="primary">
                {/* {data.destination} */}
                {Array.isArray(selectedWorkSpace)
                  ? selectedWorkSpace[0]?.destination_country
                  : ""}
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* Top Chart */}
        <Box sx={{ height: { xs: 220, md: 260 }, mt: 3 }}>
          <Typography
            fontSize={14}
            mb={1}
            fontWeight={600}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            DDP Price of all Sourcing Countries
          </Typography>
          {ddpPriceData?.ddpPrices?.length > 0 && (
            <ResponsiveBar
              data={ddpPriceData?.ddpPrices}
              keys={
                ddpPriceData?.ddpPrices.length > 0
                  ? Object.keys(ddpPriceData?.ddpPrices[0]).filter(
                      (key) => key !== "quarter",
                    )
                  : []
              }
              indexBy="quarter"
              groupMode="grouped"
              margin={{
                top: 20,
                right: isMobile ? 10 : 20,
                bottom: isMobile ? 30 : 85,
                left: isMobile ? 30 : 40,
              }}
              padding={isMobile ? 0.25 : 0.4}
              xScale={{
                stacked: false,
              }}
              // axisLeft={{
              //   tickSize: 0,
              //   tickPadding: 8,
              //   tickValues: 4, // 👈 Nivo decides: e.g. 0, 50, 100, 150
              // }}
              borderWidth={5}
              valueFormat={(v) => Number(v)?.toFixed(1)}
              borderColor="#ffffff"
              colors={["#2d0b59", "#7f3bf4", "#d4b5ff"]}
              enableLabel={false}
              axisBottom={{ tickSize: 0 }}
              axisLeft={{ tickSize: 0, tickValues: 6 }}
              enableGridX={false}
              enableGridY={false}
              legends={
                isMobile
                  ? []
                  : [
                      {
                        anchor: "bottom",
                        direction: "row",
                        translateY: 50,
                        itemDirection: "top-to-bottom",
                        translateX: -50,
                        itemWidth: 80,
                        itemHeight: 14,
                        symbolSize: 12,
                        itemsSpacing: 5,
                      },
                    ]
              }
            />
          )}
        </Box>

        {/* Bottom Section */}
        <Grid container spacing={2} mt={2}>
          {/* Work Space*/}
          <Grid item xs={12} md={6}>
            <Paper sx={{ ...chartCard, margin: "0px 8px 16px 8px" }}>
              <Select
                fullWidth
                size="small"
                // value={selectedQuarter || ""}
                value={selectedQuarter?.id || ""}
                displayEmpty
                onChange={(e) => {
                  const id = e.target.value;
                  const fullObject = quarter.find((q) => q.id === id);
                  setSelectedQuarter(fullObject);
                }}
              >
                {quarter?.length > 0 &&
                  quarter?.map((q) => (
                    <MenuItem key={q.id} value={q.id}>
                      {q?.name}
                    </MenuItem>
                  ))}
              </Select>

              <Typography fontSize={13} mb={1} mt={2} sx={centerDiv}>
                Cost Breakdown (USD per MT)
              </Typography>

              <Box sx={{ height: { xs: 200, md: 230 } }}>
                <ResponsiveBar
                  data={Array.isArray(costBreakdown) ? costBreakdown : []}
                  keys={
                    costBreakdown.length
                      ? Array.from(
                          new Set(
                            costBreakdown.flatMap((o) =>
                              Object.keys(o).filter((k) => k !== "country"),
                            ),
                          ),
                        ).sort(
                          (a, b) =>
                            [
                              "EXW",
                              "FOB",
                              "CIF",
                              "LOGISTICS",
                              "PORT CHARGES",
                              "OCEAN FREIGHT",
                              "TAXES",
                              "TARIFF",
                              "OTHER DUTY",
                            ].indexOf(a.toUpperCase()) -
                            [
                              "EXW",
                              "FOB",
                              "CIF",
                              "LOGISTICS",
                              "PORT CHARGES",
                              "OCEAN FREIGHT",
                              "TAXES",
                              "TARIFF",
                              "OTHER DUTY",
                            ].indexOf(b.toUpperCase()),
                        )
                      : []
                  }
                  indexBy="country"
                  layout="horizontal"
                  groupMode="stacked"
                  margin={{
                    top: 10,
                    right: 20,
                    bottom: isMobile ? 30 : 68,
                    left: isMobile ? 60 : 80,
                  }}
                  xScale={{
                    type: "linear",
                    min: "auto",
                    max: "auto",
                    stacked: false,
                    // stacked: true,
                    reverse: false,
                  }}
                  valueFormat={(v) => Number(v).toFixed(1)}
                  padding={0.3}
                  borderWidth={2}
                  borderColor="#ffffff"
                  colors={({ id }) => {
                    const key = String(id).toUpperCase();

                    if (["FOB", "CIF", "EXW"].includes(key)) return "#1E0143";

                    const colorMap = {
                      LOGISTICS: "#1021AD",
                      "PORT CHARGES": "#592DFF",
                      "OCEAN FREIGHT": "#000C8E",
                      TAXES: "#52008E",
                      TARIFF: "#901FB2",
                      OTHERS: "#5C5CC9",
                    };

                    return colorMap[key] || "#9F91F3";
                  }}
                  enableLabel={false}
                  axisLeft={{
                    tickSize: 0,
                    tickValues: costBreakdown.map((d) => d.country),
                    renderTick: AxisTickWithFlag,
                  }}
                  legends={
                    isMobile
                      ? []
                      : [
                          {
                            anchor: "bottom",
                            direction: "row",
                            translateY: 50,
                            itemDirection: "top-to-bottom",
                            translateX: -30,
                            itemWidth: 80,
                            itemHeight: 14,
                            symbolSize: 12,
                            itemsSpacing: 5,
                            data:
                              Array.isArray(costBreakdown) &&
                              costBreakdown.length > 0
                                ? (() => {
                                    const allKeys = Array.from(
                                      new Set(
                                        costBreakdown.flatMap((row) =>
                                          Object.keys(row).filter(
                                            (k) => k !== "country",
                                          ),
                                        ),
                                      ),
                                    );

                                    const finalKeys = [
                                      "Input Price",
                                      ...allKeys.filter(
                                        (k) =>
                                          !["EXW", "FOB", "CIF"].includes(
                                            k.toUpperCase(),
                                          ),
                                      ),
                                    ];

                                    return finalKeys.map((k) => ({
                                      id: k,
                                      label: k,
                                      color:
                                        k === "Input Price"
                                          ? "#1E0143"
                                          : {
                                              Logistics: "#1021AD",
                                              "Port Charges": "#592DFF",
                                              "Ocean Freight": "#000C8E",
                                              Taxes: "#52008E",
                                              Tariff: "#901FB2",
                                              Others: "#5C5CC9",
                                            }[k] || "#9F91F3",
                                    }));
                                  })()
                                : [],
                          },
                        ]
                  }
                />
              </Box>
            </Paper>
          </Grid>

          {/* RIGHT */}
          <Grid item xs={12} md={6}>
            <Paper sx={chartCard}>
              <Select
                fullWidth
                size="small"
                sx={{ mb: 1 }}
                value={country}
                onChange={(e) => setCountry(e.target.value)}
              >
                {selectedDDPCountryList?.map((c) => (
                  <MenuItem key={c} value={c}>
                    {c}
                  </MenuItem>
                ))}
              </Select>

              <Typography fontSize={13} mb={1} mt={2} sx={centerDiv}>
                Cost breakdown - Quarter Wise (USD per MT)
              </Typography>

              <Box sx={{ height: { xs: 200, md: 220 } }}>
                <ResponsiveBar
                  data={
                    Array.isArray(costBreakdownQuarterWise)
                      ? costBreakdownQuarterWise
                      : []
                  }
                  keys={
                    costBreakdownQuarterWise.length > 0
                      ? Object.keys(costBreakdownQuarterWise[0]).filter(
                          (key) => key !== "quarter",
                        )
                      : []
                  }
                  valueFormat={(v) => Number(v)?.toFixed(1)}
                  colors={[
                    "#1E0143",
                    "#1021AD",
                    "#592DFF",
                    "#000C8E",
                    "#52008E",
                    "#901FB2",
                    "#5C5CC9",
                    "#9F91F3",
                  ]}
                  indexBy="quarter"
                  margin={{
                    top: 10,
                    right: 20,
                    bottom: isMobile ? 30 : 70,
                    left: isMobile ? 60 : 90,
                  }}
                  yScale={{
                    type: "linear",
                    min: "auto",
                    max: "auto",
                    stacked: false,
                    reverse: false,
                  }}
                  legends={
                    isMobile
                      ? []
                      : [
                          {
                            anchor: "bottom",
                            direction: "row",
                            translateY: 50,
                            itemDirection: "top-to-bottom",
                            translateX: -50,
                            itemWidth: 80,
                            itemHeight: 14,
                            symbolSize: 12,
                            itemsSpacing: 5,
                          },
                        ]
                  }
                  borderWidth={2}
                  borderColor="#ffffff"
                  axisBottom={{ tickSize: 0 }}
                  axisLeft={{ tickSize: 0, tickValues: 6 }}
                  enableGridX={false}
                  enableGridY={false}
                  padding={0.6}
                  enableLabel={false}
                  // enableLabel={true}
                />
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}

/* -------------------- STYLES -------------------- */
const infoCard = {
  p: 2,
  borderRadius: 2,
  background: "#f4ecff",
  display: "flex",
  justifyContent: "center",
};
const cardHeader = {
  // display:"flex",
  // justifyContent:"center"
};

const chartCard = {
  p: 2,
  borderRadius: 2,
};

const centerDiv = { display: "center", justifyContent: "center" };
